module.exports = __webpack_public_path__ + "static/media/thumbnail.c28db21d.png";